import React from 'react';
import PhoneNumberInput from 'public/components/Auth/PhoneNumberInput';
import { FieldContainer } from 'public/components/FieldContainer';

export default function PhoneInput({
  input,
  handleInputChange,
  value,
  locked,
}) {
  const { name, label, required, placeholder } = input.fields;

  return (
    <FieldContainer key={name}>
      <label htmlFor={name}>{`${label}${required ? ' *' : ''}`}</label>
      <PhoneNumberInput
        initialValue={value || ''}
        onChange={(value) => handleInputChange({ ...input.fields, value })}
        id={name}
        name={name}
        placeholder={placeholder}
        readOnly={locked}
      />
    </FieldContainer>
  );
}
